import axiosInstance from './BaseService';

export const confirmBooking = async (bookingId: string, customerData: { customerName: string; customerPhone: string; email?: string }) => {
  try {
    const response = await axiosInstance.post(`/bookings/${bookingId}/confirm`, customerData);
    return response.data;
  } catch (error) {
    console.error('Error confirming booking:', error);
    throw error;
  }
};

export const getBookingDetails = async (bookingId: string) => {
  try {
    const response = await axiosInstance.get(`/bookings/${bookingId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching booking details:', error);
    throw error;
  }
};

export const getTicketData = async (bookingId: string) => {
  try {
    const response = await axiosInstance.get(`/tickets/booking-enquiry/${bookingId}/ticket`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ticket data:', error);
    throw error;
  }
};

export const verifyBooking = async (bookingCode: string) => {
  try {
    const response = await axiosInstance.get(`/tickets/verify/${bookingCode}`);
    return response.data;
  } catch (error) {
    console.error('Error verifying booking:', error);
    throw error;
  }
};

export const updateBookingStatus = async (bookingId: string, status: string, customerName?: string, email?: string) => {
  try {
    const response = await axiosInstance.patch(`/tickets/booking-enquiry/${bookingId}/status`, {
      status,
      customerName,
      email
    });
    return response.data;
  } catch (error) {
    console.error('Error updating booking status:', error);
    throw error;
  }
};



export const getUserBookingHistory = async (year?: string, month?: string) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    
    const response = await axiosInstance.get(`/tickets/user-bookings?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user booking history:', error);
    throw error;
  }
};

export const downloadTicket = async (bookingId: string) => {
  try {
    const response = await axiosInstance.get(`/ticket-image/ticket-image/${bookingId}`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading ticket:', error);
    throw error;
  }
};

export const getTicketOptions = async (scheduleId: string) => {
  try {
    const response = await axiosInstance.get(`/tickets/schedule/${scheduleId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ticket options:', error);
    throw error;
  }
};